









































import GuideGenreSettingDialog from '@/components/guide/GuideGenreSettingDialog.vue';
import IReservesApiModel from '@/model/api/reserves/IReservesApiModel';
import container from '@/model/ModelContainer';
import ISnackbarState from '@/model/state/snackbar/ISnackbarState';
import Util from '@/util/Util';
import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {
        GuideGenreSettingDialog,
    },
})
export default class GuideMainMenu extends Vue {
    public isOpened: boolean = false;
    public isOpenGenreSettingDialog: boolean = false;

    private reservesApiModel: IReservesApiModel = container.get<IReservesApiModel>('IReservesApiModel');
    private snackbarState: ISnackbarState = container.get<ISnackbarState>('ISnackbarState');

    public async updateReserves(): Promise<void> {
        this.isOpened = false;

        try {
            await this.reservesApiModel.updateAll();
            this.snackbarState.open({
                text: '予約情報の更新開始',
            });
        } catch (err) {
            this.snackbarState.open({
                color: 'error',
                text: '予約情報の更新を開始できませんでした。',
            });
        }
    }

    public async genreSetting(): Promise<void> {
        this.isOpened = false;
        await Util.sleep(300);
        this.isOpenGenreSettingDialog = true;
    }

    public onUpdateGenreSetting(): void {
        this.$emit('updatedgenre');
    }

    public async gotoSetting(): Promise<void> {
        await Util.move(this.$router, {
            path: '/guide/setting',
        });
    }

    public onClickMenuBackground(e: Event): boolean {
        e.stopPropagation();

        return false;
    }
}
